<template>
  <div class="wrapper-inside text-left">
    <GoBackButton />

    <div class="row">
      <div
        v-if="currentOffer"
        class="col-12 col-lg-9"
      >
        <div v-if="currentOffer">
          <OfferInfoCard
            :current-offer="currentOffer"
            @offerApply="offerApply"
          />
        </div>

        <div
          v-if="currentOffer"
          class="bg-card requirements"
        >
          <h2>{{ $t('pages.one-offer.requirements', 'Requirements') }}</h2>
          <div>
            <strong>{{ $t('pages.one-offer.minimum-studies', 'Minimum studies') }}</strong>
            <div class="mb-1">
              {{ $t(`data.levels.${currentOffer.requirementsMinStudies}`, currentOffer.requirementsMinStudies) }}
            </div>
          </div>
          <div>
            <strong>{{ $t('pages.one-offer.minimum-experience', 'Minimum experience') }}</strong>
            <div class="mb-1">
              {{ $t(`data.experience.${currentOffer.requirementsMinExp}`, currentOffer.requirementsMinExp) }}
            </div>
          </div>
          <div>
            <strong>{{ $t('pages.one-offer.necessary-knowledge', 'Necessary knowledge') }}</strong>
            <div
              class="mb-1"
              style="white-space: pre-line;"
            >
              {{ currentOffer.requirementsMinRequirements }}
            </div>
          </div>
          <hr>
          <h2>{{ $t('pages.one-offer.description', 'Description') }}</h2>
          <p
            v-if="currentOffer && currentOffer.titleTitle"
            style="white-space: pre-line; "
          >
            {{ currentOffer.titleDescription }}
          </p>
          <div v-if="currentOffer && currentOffer.categoryCategory">
            <strong>{{ $t('pages.one-offer.category', 'Offer category') }}</strong>
            <div class="mb-1">
              {{
                $t(`data.categories.${currentOffer.categoryCategory}`, currentOffer.categoryCategory)
                  + (currentOffer && currentOffer.categorySubcategory ? ',' : '')
              }}
              {{
                currentOffer.categorySubcategory
                  ? $t(`data.subcategories.${currentOffer.categorySubcategory}`, currentOffer.categorySubcategory)
                  : ''
              }}
            </div>
          </div>
          <div>
            <strong>{{ $t('pages.one-offer.industry-type', 'Type of industry') }}</strong>
            <div class="mb-1">
              {{ $t(`data.industryTypes.${currentOffer.categoryIndustryType}`, currentOffer.categoryIndustryType) }}
            </div>
          </div>
          <div>
            <strong>{{ $t('pages.one-offer.level', 'Level') }}</strong>
            <div class="mb-1">
              {{ $t(`data.levels.${currentOffer.titleLevel}`, currentOffer.titleLevel) }}
            </div>
          </div>
          <div>
            <strong>{{ $t('pages.one-offer.number-vacancies', 'Number of vacancies') }}</strong>
            <div class="mb-1">
              {{ currentOffer.titleVacancies }}
            </div>
          </div>
          <div>
            <strong>{{ $t('pages.one-offer.salary', 'Salary') }}</strong>
            <div>
              <span v-if="currentOffer.salaryShowAs === 'from-to'">
                {{
                  $t(
                    'pages.one-offer.salary-from-to', '{min} - {max} {type}',
                    {
                      min: currentOffer.salaryMinimum,
                      max: currentOffer.salaryMaximum,
                      type: $t(`data.salaryTypes.${currentOffer.salaryType}`, currentOffer.salaryType)
                    }
                  )
                }}
              </span>
              <span v-else-if="currentOffer.salaryShowAs === 'more-than'">
                {{
                  $t(
                    'pages.one-offer.salary-more-than', 'More than {min} {type}',
                    {min: currentOffer.salaryMinimum, type: currentOffer.salaryType }
                  )
                }}
              </span>
              <span v-else-if="currentOffer.salaryShowAs === 'dont-show'">
                {{ $t('pages.one-offer.salary-dont-show', 'Salary not available') }}
              </span>
            </div>
          </div>
          <div v-if="currentOffer.benefitsBenefits && (currentOffer.benefitsBenefits.length != 0 || currentOffer.benefitsIsOther)">
            <strong>{{ $t('pages.one-offer.benefits', 'Benefits') }}</strong>
            <div
              v-for="benefit of currentOffer.benefitsBenefits"
              :key="benefit"
              class="mb-1"
            >
              {{ benefit }}
            </div>
            <div
              v-if="currentOffer.benefitsIsOther === 1"
              class="mb-1"
            >
              {{ $t('pages.one-offer.other-benefits', 'Others') }}: {{ currentOffer.benefitsOtherText }}
            </div>
          </div>
          <div class="mt-2">
            <b-button
              v-if="
                !currentOffer.isArchived
                  && (currentOffer.isApplied === false || !currentOffer.isApplied)
                  && (this.$hasRole(['candidate']) || !this.$auth.check())
              "
              variant="info"
              class="apply-button"
              @click="offerApply"
            >
              {{ $t('pages.one-offer.apply-to-this-offer', 'Apply to this offer') }}
            </b-button>
            <b-button
              v-if="
                !currentOffer.isArchived
                  && (currentOffer.isApplied === true && currentOffer.isApplied != null)
                  && this.$hasRole(['candidate'])
              "
              variant="info"
              class="apply-button"
              disabled
              style="background: green; border-color: green;"
            >
              {{ $t('pages.one-offer.already-enrolled', 'Already enrolled') }}
            </b-button>
            <b-button
              v-else-if="currentOffer.isArchived && this.$auth.check() && !this.$hasRole(['candidate']) "
              variant="info"
              class="apply-button"
              disabled
              style="background: orange; border-color: orange;"
            >
              {{ $t('pages.one-offer.archived', 'Archived') }}
            </b-button>
          </div>
        </div>
      </div>
      <div v-else-if="notFound">
        <NotFound />
      </div>
      <div v-else>
        <div class="text-center">
          {{ $t('generic.loading', 'Loading') }}...
        </div>
      </div>
      <div
        class="col-12 col-lg-3 pl-lg-0"
      >
        <Advertisement />
        <ShareOffer
          v-if="currentOffer && currentOffer.titleTitle"
          :url="currentUrl"
          :title="currentOffer.titleTitle"
          :description="currentOffer.titleTitle"
          :quote="$t('pages.one-offer.sidebar.share-offer.default-message', 'I have found a job offer in :portal', {portal: appName})"
        />
      </div>
    </div>
  </div>
</template>

<script>
  import GoBackButton from '@/components/jobs/shared/GoBackButton';
  import OfferInfoCard from '@/components/jobs/public/offerInfoCard';

  import Advertisement from '@/components/jobs/infoSidebar/Advertisement.vue';
  import ShareOffer from '@/components/jobs/infoSidebar/ShareOffer.vue';
  import NotFound from "@/views/NotFound.vue";

  import {mapActions, mapGetters, mapState} from 'vuex';

  export default {
  components: {
    GoBackButton,
    OfferInfoCard,

    Advertisement,
    ShareOffer,
    NotFound
  },
  data() {
    return {
      notFound: false,
    }
  },
  computed: {
    ...mapState ({
      ...mapGetters('offers', {
        offerById: 'byId',
        offerLoading: 'isLoading',
      }),

      ...mapState([
        'route', // vuex-router-sync
      ]),
      currentOffer() {
        return this.offerById(this.$route.params.id);
      },
      generateSlug() {
        return this.currentOffer.user.company.title.replace(/[^A-Z0-9]+/ig, "-").toLowerCase();
      },
    }),

    currentUrl() {
      return window.location.href;
    },

    appName() {
      return process.env.VUE_APP_NAME;
    }
  },
  watch: {
    $route: 'fetchData',
  },
  created() {
    this.fetchData();
  },
  mounted() {
    if (this.$route.params.id && this.offerProp) {
      this.currentOffer = this.offerProp;
    }
  },
  methods: {
    ...mapActions('offers', {
      fetchOffer: 'fetchSingle',
    }),
    async fetchData() {
      try {
        return await this.fetchOffer({
          customUrl: '/offer/one/' + this.$route.params.id,
          id: this.$route.params.id
        });
      } catch (e) {
        this.notFound = true;
        return null;
      }
    },
    offerApply() {
      if(this.$auth.check()) {
        this.$router.push({ name: 'apply-offer', params: { offer: this.currentOffer} });
      } else {
        this.$router.push({ name: 'Login', params: {redirectTo: { name: 'apply-offer', params: { offer: this.currentOffer}}}})
      }
    },
    mysqlTimeStampToDate(timestamp) {
      //function parses mysql datetime string and returns javascript Date object
      //input has to be in this format: 2007-06-05 15:26:02
      var regex=/^([0-9]{2,4})-([0-1][0-9])-([0-3][0-9]) (?:([0-2][0-9]):([0-5][0-9]):([0-5][0-9]))?$/;
      var parts=timestamp.replace(regex,"$1 $2 $3 $4 $5 $6").split(' ');
      return new Date(parts[0],parts[1]-1,parts[2],parts[3],parts[4],parts[5]);
    }
  }
}
</script>

<style scoped lang="scss">
  .requirements {
    font-size: 0.9rem;
  }

  .apply-button {
    font-size: 0.9rem;
    font-weight: 600;
    background: #ff6340;
    border: 1px solid #ff6340;
    text-transform: uppercase;

    &:hover {
      background: #ff4e27;
    }
  }
</style>
